<template>
  <div id="PurchaseReturnMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">供应商</span>
            <el-select v-model="params.supplierId" size="small" filterable clearable placeholder="全部">
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">退货单号</span>
            <el-input v-model="params.returnGroupId" size="small" clearable placeholder="请输入退货单号"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品名称</span>
            <el-input v-model="params.productName" size="small" clearable placeholder="请输入产品名称"></el-input>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label" class="status-tab-label">
            {{ tab.label }}
            <el-badge v-if="tab.showBadge && statusCounts[tab.name] > 0" :value="statusCounts[tab.name]" class="status-tab-badge"></el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="table-container">
        <el-table
          ref="returnTable"
          :data="tableData"
          border
          stripe
          size="mini"
          :height="screenHeight"
          v-loading="loading"
          element-loading-text="加载中..."
          :span-method="spanMethod"
          header-cell-class-name="table-header-cell"
          class="mgmt-table"
        >
          <el-table-column label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              <span v-if="scope.row._returnRowSpan > 0">{{ getGroupRowIndex(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shopName" label="店铺" width="70" align="center" class-name="merge-col" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierShortName" label="供应商" width="100" class-name="merge-col" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.supplierShortName || scope.row.supplierName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="160">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.productName && String(scope.row.productName).length > 20"
                :content="scope.row.productName"
                placement="top"
              >
                <span>{{ truncateText(scope.row.productName, 20) }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.productName || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="returnQuantity" label="退货数量" width="80" align="right"></el-table-column>
          <el-table-column label="退货证明" width="120" align="center" class-name="merge-col">
            <template slot-scope="scope">
              <div v-if="getProofImageList(scope.row, 'returnProof').length" class="proof-thumb-list">
                <el-image
                  v-for="(url, index) in getProofImageList(scope.row, 'returnProof')"
                  :key="url + '-' + index"
                  :src="url"
                  :preview-src-list="getProofImageList(scope.row, 'returnProof')"
                  fit="cover"
                  class="proof-thumb"
                ></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="200" class-name="merge-col remark-col">
            <template slot-scope="scope">
              <div class="remark-text">{{ scope.row.remark || "-" }}</div>
              <div v-if="scope.row.rejectRemark" class="reject-remark">打回：{{ scope.row.rejectRemark }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="退货状态" width="120" align="center" class-name="merge-col"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="150" align="center" class-name="merge-col">
            <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="340" align="center" class-name="merge-col action-col">
            <template slot-scope="scope">
              <div v-if="scope.row._returnRowSpan > 0" class="action-cell action-cell-nowrap">
                <el-button v-if="scope.row.status === '待确认退货信息'" type="text" size="small" @click="confirmReturnInfo(scope.row)">确认退货信息</el-button>
                <el-button v-if="scope.row.status === '待退货'" type="text" size="small" @click="openProofUpload(scope.row)">上传采购退货证明</el-button>
                <el-button v-if="scope.row.status === '待退货'" type="text" size="small" class="success" @click="openConfirmReturn(scope.row)">确认退货</el-button>
                <el-button v-if="scope.row.status === '待确认退货信息' || scope.row.status === '待退货'" type="text" size="small" class="danger" @click="voidReturn(scope.row)">作废</el-button>
                <el-button type="text" size="small" @click="openPurchaseRecords(scope.row)">退货明细</el-button>
                <el-button type="text" size="small" @click="showOpreateLog(scope.row)">操作记录</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" min-width="80" class-name="merge-col filler-col"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          background
          prev-text="上一页"
          next-text="下一页"
          :current-page.sync="currentPage"
          :page-size="params.pageSize"
          :total="total"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="上传采购退货证明" :visible.sync="proofUploadVisible" width="640px" custom-class="return-proof-dialog" :close-on-click-modal="false" @opened="onProofUploadDialogOpened" @closed="onProofUploadDialogClosed">
      <div ref="proofPastePanel" class="proof-upload-panel" tabindex="0" v-loading="proofUploading">
        <div class="proof-upload-list">
          <div v-for="(url, index) in proofUploadUrls" :key="url + '-' + index" class="proof-upload-item">
            <el-image :src="url" fit="cover" class="proof-upload-image"></el-image>
            <i class="el-icon-error proof-upload-remove" @click="removeProofUploadImage(index)"></i>
          </div>
          <el-upload
            class="proof-upload-add"
            action="/biz/oss/upload"
            name="file"
            accept="image/*"
            :data="{ bizModule: 'return' }"
            :show-file-list="false"
            :before-upload="beforeProofImageUpload"
            :on-success="handleProofUploadSuccess"
            :disabled="proofUploading"
          >
            <div class="proof-upload-trigger">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <span class="proof-upload-text">添加图片</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持 JPG、PNG、GIF、WEBP、BMP；可上传多张，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proofUploadVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveProofUpload" :loading="proofUploadSaving">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认退货" :visible.sync="confirmReturnVisible" width="680px" :close-on-click-modal="false" @opened="onConfirmProofDialogOpened" @closed="onConfirmProofDialogClosed">
      <div class="finance-confirm-tip">请确认退货证明无误后点击「确认已退货」；如需打回，请填写原因。</div>
      <div ref="confirmPastePanel" class="proof-upload-panel" tabindex="0" v-loading="proofUploading">
        <div class="proof-upload-list">
          <div v-for="(url, index) in confirmProofUrls" :key="url + '-' + index" class="proof-upload-item">
            <el-image :src="url" fit="cover" class="proof-upload-image"></el-image>
            <i class="el-icon-error proof-upload-remove" @click="confirmProofUrls.splice(index, 1)"></i>
          </div>
          <el-upload
            class="proof-upload-add"
            action="/biz/oss/upload"
            name="file"
            accept="image/*"
            :data="{ bizModule: 'return' }"
            :show-file-list="false"
            :before-upload="beforeProofImageUpload"
            :on-success="handleConfirmProofUploadSuccess"
            :disabled="proofUploading"
          >
            <div class="proof-upload-trigger">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <span class="proof-upload-text">添加图片</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持多张图片，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <el-form label-width="80px" style="margin-top: 16px">
        <el-form-item label="打回原因">
          <el-input v-model="rejectRemark" type="textarea" :rows="2" placeholder="打回时必填"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmReturnVisible = false">取 消</el-button>
        <el-button type="warning" @click="confirmReject" :loading="confirmSaving">打 回</el-button>
        <el-button type="primary" @click="confirmReturned" :loading="confirmSaving">确认已退货</el-button>
      </div>
    </el-dialog>

    <el-dialog title="退货明细" :visible.sync="purchaseRecordsVisible" width="900px">
      <el-table :data="purchaseRecords" border stripe size="mini" max-height="420" v-loading="purchaseRecordsLoading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="date" label="采购日期" width="100" align="center"></el-table-column>
        <el-table-column prop="shopName" label="店铺" width="70"></el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sku" label="SKU" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="model" label="机型" width="90"></el-table-column>
        <el-table-column prop="returnQuantity" label="退货数量" width="80" align="right"></el-table-column>
        <el-table-column prop="orderNo" label="采购单号" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.orderNo || scope.row.purchaseId || "" }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="purchaseRecordsVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="960px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" v-loading="opreateLogLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { purchaseReturnModules, requestModules, ossModules } from "@r";

const STATUS_TABS = [
  { name: "待确认退货信息", label: "待确认退货信息", showBadge: true },
  { name: "待退货", label: "待退货", showBadge: true },
  { name: "已退货", label: "已退货", showBadge: false },
  { name: "已作废", label: "已作废", showBadge: false },
  { name: "全部", label: "全部", showBadge: false },
];

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: document.body.clientHeight - 64 - 120 - 100,
      supplierList: [],
      activeStatusTab: "待确认退货信息",
      statusTabs: STATUS_TABS,
      statusCounts: {
        待确认退货信息: 0,
        待退货: 0,
        已退货: 0,
        已作废: 0,
      },
      params: {
        supplierId: "",
        returnGroupId: "",
        productName: "",
        beginIndex: 0,
        pageSize: 100,
      },
      proofUploadVisible: false,
      proofUploadUrls: [],
      proofUploadRow: null,
      proofUploadSaving: false,
      proofUploading: false,
      confirmReturnVisible: false,
      confirmReturnRow: null,
      confirmProofUrls: [],
      rejectRemark: "",
      confirmSaving: false,
      purchaseRecordsVisible: false,
      purchaseRecordsLoading: false,
      purchaseRecords: [],
      opreateLogVisible: false,
      opreateLogLoading: false,
      operateHistory: [],
    };
  },
  mounted() {
    this.loadSuppliers();
    this.getData();
    this.$nextTick(() => this.calculateHeight());
    this.$eventBus && this.$eventBus.$on && this.$eventBus.$on("resize", this.calculateHeight);
    window.addEventListener("resize", this.calculateHeight);
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.handleProofPaste);
    document.removeEventListener("paste", this.handleConfirmProofPaste);
    window.removeEventListener("resize", this.calculateHeight);
    this.$eventBus && this.$eventBus.$off && this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    loadSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata || [];
      });
    },
    calculateHeight() {
      let panel = this.$refs.tablePanel;
      if (!panel) {
        return;
      }
      let tabs = panel.querySelector(".status-tabs");
      let pagination = panel.querySelector(".pagination-box");
      let panelStyle = window.getComputedStyle(panel);
      let paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      let paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      let available =
        panel.clientHeight -
        paddingTop -
        paddingBottom -
        (tabs ? tabs.offsetHeight + 12 : 0) -
        (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    queryBtn() {
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    onStatusTabChange(tab) {
      this.activeStatusTab = tab.name;
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.getData();
    },
    getData() {
      this.loading = true;
      let params = {
        ...this.params,
        statusTab: this.activeStatusTab === "全部" ? "" : this.activeStatusTab,
      };
      purchaseReturnModules
        .fetchReturns(params)
        .then(res => {
          this.tableData = res.ldata || [];
          this.total = res.total || 0;
          this.statusCounts = {
            待确认退货信息: 0,
            待退货: 0,
            已退货: 0,
            已作废: 0,
            ...(res.mdata && res.mdata.statusCounts ? res.mdata.statusCounts : {}),
          };
        })
        .finally(() => {
          this.loading = false;
          this.$nextTick(() => this.calculateHeight());
        });
    },
    getGroupRowIndex(row) {
      let index = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (item._returnRowSpan > 0) {
          index++;
          if (item.returnGroupId === row.returnGroupId) {
            return index;
          }
        }
      }
      return index;
    },
    formatTime(ts) {
      if (!ts) return "-";
      const date = new Date(Number(ts));
      if (Number.isNaN(date.getTime())) return "-";
      const pad = n => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    truncateText(value, maxLen) {
      let text = value == null ? "" : String(value);
      if (!text) {
        return "";
      }
      if (!maxLen || text.length <= maxLen) {
        return text;
      }
      return text.slice(0, maxLen) + "…";
    },
    spanMethod({ column, row }) {
      let shouldMerge =
        column.label === "序号" ||
        column.label === "操作" ||
        column.label === "退货证明" ||
        column.label === "备注" ||
        column.label === "退货状态" ||
        column.label === "创建时间" ||
        column.label === "供应商" ||
        column.label === "店铺" ||
        column.label === "" ||
        column.property === "shopName" ||
        column.property === "supplierShortName" ||
        column.property === "remark" ||
        column.property === "status";
      if (!shouldMerge) {
        return [1, 1];
      }
      if (row._returnRowSpan > 0) {
        return [row._returnRowSpan, 1];
      }
      return [0, 0];
    },
    normalizeProofImageList(value) {
      if (value == null || value === "") {
        return [];
      }
      if (Array.isArray(value)) {
        return value.map(item => String(item || "").trim()).filter(Boolean);
      }
      if (typeof value === "string") {
        let trimmed = value.trim();
        if (!trimmed) {
          return [];
        }
        if (trimmed.charAt(0) === "[") {
          try {
            let parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              return parsed.map(item => String(item || "").trim()).filter(Boolean);
            }
          } catch (error) {
            return [trimmed];
          }
        }
        return [trimmed];
      }
      return [];
    },
    getProofImageList(row, field) {
      return this.normalizeProofImageList(row[field]);
    },
    confirmReturnInfo(row) {
      this.$confirm("确认退货信息无误，流转到「待退货」？", "确认退货信息", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        purchaseReturnModules
          .updateReturnStatus({
            returnGroupId: row.returnGroupId,
            targetStatus: "待退货",
          })
          .then(res => {
            if (res.result !== 1) {
              this.$message.error(res.message || "操作失败");
              return;
            }
            this.$message.success("已确认退货信息");
            this.getData();
          });
      });
    },
    voidReturn(row) {
      this.$confirm("确认作废该退货单？", "作废", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        purchaseReturnModules
          .updateReturnStatus({
            returnGroupId: row.returnGroupId,
            targetStatus: "已作废",
          })
          .then(res => {
            if (res.result !== 1) {
              this.$message.error(res.message || "操作失败");
              return;
            }
            this.$message.success("已作废");
            this.getData();
          });
      });
    },
    openProofUpload(row) {
      this.proofUploadRow = row;
      this.proofUploadUrls = [...this.getProofImageList(row, "returnProof")];
      this.proofUploadVisible = true;
    },
    onProofUploadDialogOpened() {
      document.addEventListener("paste", this.handleProofPaste);
      this.$nextTick(() => {
        if (this.$refs.proofPastePanel) {
          this.$refs.proofPastePanel.focus();
        }
      });
    },
    onProofUploadDialogClosed() {
      document.removeEventListener("paste", this.handleProofPaste);
      this.proofUploading = false;
    },
    isProofImageFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      let name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    beforeProofImageUpload(file) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请上传图片文件");
        return false;
      }
      return true;
    },
    handleProofPaste(event) {
      if (!this.proofUploadVisible || this.proofUploading) {
        return;
      }
      let items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          let file = item.getAsFile();
          if (file) {
            this.uploadProofImageFile(file, urls => {
              this.proofUploadUrls = urls;
            }, this.proofUploadUrls);
          }
          return;
        }
      }
    },
    uploadProofImageFile(file, onSuccess, currentUrls) {
      if (!this.isProofImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "return");
      this.proofUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            onSuccess([...(currentUrls || []), res.objData.fileUrl]);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.proofUploading = false;
        });
    },
    handleProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.proofUploadUrls.push(res.objData.fileUrl);
        return;
      }
      this.$message.error("上传失败");
    },
    removeProofUploadImage(index) {
      this.proofUploadUrls.splice(index, 1);
    },
    saveProofUpload() {
      if (!this.proofUploadRow) {
        return;
      }
      if (!this.proofUploadUrls.length) {
        this.$message.error("请先上传图片");
        return;
      }
      this.proofUploadSaving = true;
      purchaseReturnModules
        .updateReturnAttachment({
          returnGroupId: this.proofUploadRow.returnGroupId,
          returnProof: JSON.stringify(this.proofUploadUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.proofUploadVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message.error(err.message || "保存失败");
        })
        .finally(() => {
          this.proofUploadSaving = false;
        });
    },
    openConfirmReturn(row) {
      this.confirmReturnRow = row;
      this.confirmProofUrls = [...this.getProofImageList(row, "returnProof")];
      this.rejectRemark = "";
      this.confirmReturnVisible = true;
    },
    onConfirmProofDialogOpened() {
      document.addEventListener("paste", this.handleConfirmProofPaste);
      this.$nextTick(() => {
        if (this.$refs.confirmPastePanel) {
          this.$refs.confirmPastePanel.focus();
        }
      });
    },
    onConfirmProofDialogClosed() {
      document.removeEventListener("paste", this.handleConfirmProofPaste);
      this.proofUploading = false;
    },
    handleConfirmProofPaste(event) {
      if (!this.confirmReturnVisible || this.proofUploading) {
        return;
      }
      let items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          let file = item.getAsFile();
          if (file) {
            this.uploadProofImageFile(
              file,
              urls => {
                this.confirmProofUrls = urls;
              },
              this.confirmProofUrls
            );
          }
          return;
        }
      }
    },
    handleConfirmProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.confirmProofUrls.push(res.objData.fileUrl);
        return;
      }
      this.$message.error("上传失败");
    },
    confirmReturned() {
      if (!this.confirmReturnRow) {
        return;
      }
      if (!this.confirmProofUrls.length) {
        this.$message.error("请先上传退货证明");
        return;
      }
      this.confirmSaving = true;
      purchaseReturnModules
        .updateReturnStatus({
          returnGroupId: this.confirmReturnRow.returnGroupId,
          targetStatus: "已退货",
          returnProof: JSON.stringify(this.confirmProofUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success("已确认退货");
          this.confirmReturnVisible = false;
          this.getData();
        })
        .finally(() => {
          this.confirmSaving = false;
        });
    },
    confirmReject() {
      if (!this.rejectRemark || !this.rejectRemark.trim()) {
        this.$message.error("请填写打回原因");
        return;
      }
      this.confirmSaving = true;
      purchaseReturnModules
        .updateReturnStatus({
          returnGroupId: this.confirmReturnRow.returnGroupId,
          targetStatus: "待确认退货信息",
          rejectRemark: this.rejectRemark.trim(),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "打回失败");
            return;
          }
          this.$message.success("已打回至待确认退货信息");
          this.confirmReturnVisible = false;
          this.getData();
        })
        .finally(() => {
          this.confirmSaving = false;
        });
    },
    openPurchaseRecords(row) {
      if (!row || !row.returnGroupId) {
        this.$message.warning("缺少退货单号");
        return;
      }
      this.purchaseRecordsVisible = true;
      this.purchaseRecordsLoading = true;
      this.purchaseRecords = [];
      purchaseReturnModules
        .fetchReturnPurchaseRecords({ returnGroupId: row.returnGroupId })
        .then(res => {
          if (res.result !== 1) {
            this.purchaseRecordsVisible = false;
            this.$message.error(res.message || "获取退货明细失败");
            return;
          }
          this.purchaseRecords = res.ldata || [];
          if (!this.purchaseRecords.length) {
            this.$message.info("暂无退货明细");
          }
        })
        .catch(() => {
          this.purchaseRecordsVisible = false;
          this.$message.error("获取退货明细失败");
        })
        .finally(() => {
          this.purchaseRecordsLoading = false;
        });
    },
    showOpreateLog(row) {
      if (!row || !row.returnGroupId) {
        this.$message.warning("缺少退货单号");
        return;
      }
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: row.returnGroupId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
          if (!this.operateHistory.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#PurchaseReturnMgmt {
  .remark-col .cell {
    line-height: 1.4;
  }

  .remark-text,
  .reject-remark {
    white-space: pre-wrap;
    word-break: break-word;
  }

  .reject-remark {
    margin-top: 4px;
    color: #e6a23c;
    font-size: 12px;
  }

  .filler-col .cell {
    padding: 0;
  }

  .action-cell .success {
    color: #67c23a;
  }

  .action-cell .danger {
    color: #f56c6c;
  }

  .proof-thumb-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
    padding: 2px 0;
  }

  .proof-thumb {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    vertical-align: middle;
  }

  .proof-empty {
    color: #c0c4cc;
  }

  .finance-confirm-tip {
    margin-bottom: 12px;
    color: #606266;
    font-size: 13px;
  }
}

.return-proof-dialog,
#PurchaseReturnMgmt {
  .proof-upload-panel {
    outline: none;
  }

  .proof-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .proof-upload-item {
    position: relative;
    width: 96px;
    height: 96px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
  }

  .proof-upload-image {
    width: 100%;
    height: 100%;
  }

  .proof-upload-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    color: #f56c6c;
    font-size: 18px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
  }

  .proof-upload-add .el-upload {
    width: 96px;
    height: 96px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
  }

  .proof-upload-add .el-upload:hover {
    border-color: #409eff;
  }

  .proof-upload-trigger {
    width: 96px;
    height: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8c939d;
  }

  .proof-upload-text {
    margin-top: 6px;
    font-size: 12px;
  }

  .proof-upload-tip {
    margin-top: 12px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
